export default __webpack_public_path__ + "static/media/178.16317571.jpg";